export default __webpack_public_path__ + "static/media/data-download.9d43ef7d.svg";